/*!
 * Driftless Glen Distillery - Big Thirst Headless Loader
 *
 * Install this stable file once on the target site. It fetches the config with
 * a fresh query string so future config and engine updates stay cache-safe.
 */

(function () {
  'use strict';

  if (window.__BT_DRIFTLESS_GLEN_LOADER_LOADED) return;
  window.__BT_DRIFTLESS_GLEN_LOADER_LOADED = true;

  var DEFAULT_CONFIG_SRC = 'https://driftlessglendistillery.myshopify.com/cdn/shop/files/driftless-glen-config.js';
  var configSrc = window.__BT_DRIFTLESS_GLEN_CONFIG_SRC || DEFAULT_CONFIG_SRC;
  var configVersion = window.__BT_DRIFTLESS_GLEN_CONFIG_VERSION || String(Date.now());
  var separator = configSrc.indexOf('?') === -1 ? '?' : '&';
  var head = document.head || document.documentElement;
  var script = document.createElement('script');

  script.src = configSrc + separator + 'v=' + encodeURIComponent(configVersion);
  script.async = false;
  script.setAttribute('data-bt-driftless-glen-config', 'true');
  head.appendChild(script);
})();
